import React, { useState, useEffect } from 'react';
import ReactEcharts from 'echarts-for-react';

const OverAllRisk = () => {
    const getOption = () => ({
        tooltip: {
            formatter: "{a} <br/>{b} : {c}%"
        },
        toolbox: {
            feature: {
                restore: {},
                saveAsImage: {}
            }
        },
        series: [
            {
                name: 'Over All Risk',
                type: 'gauge',
                detail: { formatter: '{value}%' },
                axisLine: {
                    lineStyle: {
                        color: [
                            [0.2, '#5C6673'],  
                            [0.6, '#A3E566'],  
                            [1, '#2F80F7']      
                        ],
                        width: 20
                    }
                },
                data: [{ value: 50.2, name: 'Over All Risk' }]
            }
        ]
    });

    const [option, setOption] = useState(getOption());

    

    return <ReactEcharts style={{ height: "350px" }} option={option} />;
};

export default OverAllRisk;
